import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customerService } from '../api/services/customerService';
import type { CreateCustomerInput, UpdateCustomerInput } from '../types/api';

export function useCustomerMutation() {
  const queryClient = useQueryClient();

  const createCustomerMutation = useMutation({
    mutationFn: (data: CreateCustomerInput) => customerService.createCustomer(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customers'] });
    },
  });

  const updateCustomerMutation = useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateCustomerInput }) =>
      customerService.updateCustomer(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customers'] });
    },
  });

  const deleteCustomerMutation = useMutation({
    mutationFn: (id: string) => customerService.deleteCustomer(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customers'] });
    },
  });

  return {
    createCustomer: createCustomerMutation.mutateAsync,
    updateCustomer: updateCustomerMutation.mutateAsync,
    deleteCustomer: deleteCustomerMutation.mutateAsync,
    isLoading:
      createCustomerMutation.isPending ||
      updateCustomerMutation.isPending ||
      deleteCustomerMutation.isPending,
    error:
      createCustomerMutation.error ||
      updateCustomerMutation.error ||
      deleteCustomerMutation.error,
  };
}
